export default "__VITE_ASSET__QbLsW7Ex__"